// 連帯債務者・保証人制御用カスタムhooks
import React, { useState } from 'react';
import { Content } from '../types/Template';
import { fm_types } from '../Const';

/**
 * 連帯債務者・保証人の人数を返却する
 * 画面上に項目が存在しない場合、既存の値を使用する
 *
 * @param contents 画面表示コンテンツ
 */
export const useFilterGuarantor = (contents: Content[]) => {
  const [guarantors_num, setGuarantorsNum] = useState(0);

  /**
   * 連帯債務者・保証人の人数を返却する
   *
   * @return {number | null} 連帯債務者・保証人数
   */
  const filterGuarantors = () => {
    const guarantors_count = contents.filter(
      content =>
        content.fm_type === fm_types.guarantor_num ||
        content.fm_type === fm_types.guarantornum_select
    );
    if (guarantors_count.length !== 0) {
      return guarantors_count[0].value ? Number(guarantors_count[0].value) : 0;
    } else {
      return Number(guarantors_num);
    }
  };

  return [filterGuarantors(), setGuarantorsNum] as const;
};
